import { APPLICATION_TYPE, APPLICATION_TYPE_STRING_KEYS } from '../constants';

export const applicationTypeStringHelper = (value) => {
  if (!value) {
    return null;
  }

  if (typeof value === 'string') {
    return `${APPLICATION_TYPE_STRING_KEYS[`${value}`]}Application`;
  }

  return `${APPLICATION_TYPE[value]}Application`;
};

export const applicationTypeHelper = (value) => {
  if (!value) {
    return null;
  }

  return `${value}Application`;
};
